<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form
            class="container-fluid justify-content-start"
            v-if="redeem.hubspot_id !== undefined"
          >
            <div>
              <a href="https://app.loyaltyhub.me/RedeemHistory">
              <img
              style="width: 6%"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/11/previous.png"
          />
          </a>
            </div>

            <!--p style="margin-left: auto;margin-top: -29px;">เลขที่คำสั่ง : {{ redeem.hubspot_id }}</!--p-->

            <div class="line-c">
              <hr class="new4" />
            </div>
          </form>
        </nav>
      </div>
      <div class="row bg-white s" v-if="redeem.hubspot_id !== undefined">
        <div style="width: 100%; margin-left: auto; margin-right: auto" class="col">
          <img
            style="width: 80%"
            :src="'https://api.loyaltyhub.me/public/' + redeem.rewardId.image"
            v-if="redeem.rewardId !== undefined"
          />
        </div>
        <div style="width: 100%" class="col order-history">
          <span class="name-now">{{ redeemDate }} น.</span>
          <span class="name-product">{{ redeem.reward_name }}</span>
          <span class="name-price"
            >{{ redeem.point | numFormat("0,000,000") }} คะแนน ({{
              redeem.status | translateStatus
            }})</span
          >
        </div>
      </div>
      <div class="" v-if="redeem.hubspot_id !== undefined">
        <div class="row">
        </div>
      </div>
      <div v-if="redeem.shipping_name !== undefined">
        <div>
          <span class="wordorder">จัดส่ง</span>
        </div>
        <div class="det">
          <span class="name-customer"
            ><pre>          {{ redeem.shipping_name }}
            {{ redeem.shipping_phone }}
            {{ redeem.shipping_address }}
            {{ redeem.shipping_state }}
            {{ redeem.shipping_postcode }}</pre>
          </span>
        </div>
        <div v-if="redeem.hubspot_id !== undefined">
          <span class="wordorder">ข้อมูลจัดส่ง</span>
        </div>

        <div class="det" v-if="redeem.tracking_information !== undefined">
          <span class="name-customer"
            ><pre>          {{ redeem.tracking_information.company }}
            {{ redeem.tracking_information.tracking_code }}
            {{ redeem.tracking_information.tracking_date }}</pre>
          </span>
        </div>
      </div>
    </body>
  </html>
</template>
<script>
import { DateTimeFunc } from "../libs/constant.js";
import Navbar from "./navbar";
export default {
  name: "OrderHistory",
  components: {
    navbar: Navbar,
  },
  data() {
    return {
      redeem: {},
    };
  },
  filters: {
    translateStatus: function (val) {
      if (val == "Completed" || val == "Approved") {
        return "สำเร็จ";
      } else if (val == "Cancelled" || val == "Cancelled") {
        return "ยกเลิก";
      } else {
        return "กำลังดำเนินการ";
      }
    },
  },
  computed: {
    redeemDate() {
      return DateTimeFunc.reformatDate(this.redeem.createdAt || new Date());
    },
  },
  beforeMount() {
    console.log(this.$route);
    // console.log(this.$router);
    console.log(this.$store.state.redeem);

    //return this.$store.state.orderList[this.$route.params.rewardId || 0];
    //console.log(this.$store.state.redeem.history[this.$route.params.rewardIndex]);
    //this.redeem = this.$store.state.redeem.history.indexOf(
    //  this.$route.params.rewardIndex
    //);

    this.$store
      .dispatch("getRedeemInformation", this.$route.params.rewardIndex)
      .then((response) => {
        console.log(response);
        this.redeem = response.data;
      });
  },

  watch: {
    redeem: {
      handler(val) {
        console.log(val);
      },
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.name-company {
  color: #7f8285a9;
  font-size: 13px;
  padding: 5px 5px 5px 10px;
}
pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: .875em;
    font-family: 'Prompt';
    color: black;
    margin-left: -35px;
}
.name-cutumer {
  font-family: "Prompt";
  color: #7f8285a9;
  font-size: 13px;
  padding: 5px 5px 5px 10px;
}
.name-locat {
  font-family: "Prompt";
  color: #7f828596;
  margin-top: 50px;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.det {
  margin-top: -43px;
  padding: 5px 15px 15px 15px;
}
.iconthreet {
  display: block;
  margin-right: 3px;
  margin-top: 11px;
  float: left;
}
.icon-t {
  display: block;
  margin-left: 3px;
  margin-right: 16px;
  margin-top: -6px;
  float: left;
}
.iconpoint {
  display: block;
  margin-left: 16px;
  margin-right: -14px;
  margin-top: 7px;
  width: 27px;
  height: 27px;
  float: left;
  padding: 3px 3px 3px 3px;
}
hr.new4 {
  border: 1px solid #848484;
  height: 1px;
  border-radius: 73px;
}
.line-c {
  display: table;
  top: 34px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  border-radius: 30px;
  left: 0px;
}
.line-d {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 211px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
  float: left;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: 0px;
}
.btn-outline-success {
  font-family: "Prompt";
  color: #7f8285;
  border-color: #963c3c00;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
}
.btn-outline-secondary {
  font-family: "Prompt";
  color: #7bc79a;
  border-color: #ffffff00;
  font-weight: bold;
  width: 100%;
  float: left;
  font-size: 19px;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: "Prompt";
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background-color: #fff0 !important;
}
.bg-white.s {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
  top: -6px;
}
.bg-white.ss {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
p {
  font-size: 13px;
  color: #7f8285;
  text-align: center;
  margin-left: -54px;
  margin-top: 7px;
}
.img-profile {
  display: block;
  width: 124px;
  height: 125px;
  float: left;
  margin-left: -15px;
  left: 0px;
  border-radius: 0;
  margin-top: 0px;
}
.name-status {
  font-family: "Prompt";
  color: #7bc79a;
  margin-top: 13px;
  font-size: 0.6em;
  font-weight: bold;
}
.name-now {
  font-family: "Prompt";
  color: #585858cb;
  margin-top: 13px;
  font-size: 0.6em;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
  font-family: "Prompt";
  color: #7bc79a;
  margin-top: 3px;
  font-size: 0.6em;
  padding: 0px 0px 0px 21px;
  float: right;
}
.name-product {
  font-family: "Prompt";
  color: #000000;
  font-size: 0.8em;
  padding: 2px 2px 15px 21px;
}

.name-category {
  min-width: 100%;
  font-size: 0.5em;
  display: block;
  color: #030303;
}
.wordorder {
  font-family: "Prompt";
  color: #000000;
  margin-top: 3px;
  font-size: 0.7em;
  padding: 10px 10px 0px 21px;
  margin-left:10px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
.row[data-v-eb54a8a2] {
  margin-bottom: 15px;
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0) !important;
  padding-left: calc(var(--bs-gutter-x) * 0) !important;
  margin-top: var(--bs-gutter-y);
}
.fixios {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
}
</style>
